import React, { useCallback, useEffect, useState } from "react";
import { getPublishLog } from "./happyschoolApi";

// Nhật ký công bố / gỡ công bố (lưu trong DB: publishLog/{schoolId}) — chỉ ghi thêm, không sửa/xoá.
//  kind="tkb"   + weekId   : các lần công bố/gỡ bản TKB của 1 tuần
//  kind="luong" + monthKey : các lần công bố/thu hồi lương của 1 tháng
const fmtAt = (t) => {
  if (!t) return "—";
  const d = new Date(Number(t) + 7 * 3600 * 1000).toISOString(); // giờ Việt Nam
  return `${d.slice(8, 10)}/${d.slice(5, 7)}/${d.slice(0, 4)} ${d.slice(11, 19)}`;
};
const actionOf = (e) => {
  if (e.kind === "luong") return e.action === "publish" ? { t: "✅ Công bố lương", c: "#166534", bg: "#dcfce7" } : { t: "↩ Thu hồi công bố lương", c: "#92400e", bg: "#fef3c7" };
  if (e.action === "publish") return e.mode === "demo" ? { t: "🧪 Công bố DEMO", c: "#92400e", bg: "#fef3c7" } : { t: "✅ Công bố chính thức", c: "#166534", bg: "#dcfce7" };
  if (e.action === "auto-unpublish") return { t: "♻ Tự gỡ (do công bố bản khác)", c: "#475569", bg: "#f1f5f9" };
  return { t: "⏹ Gỡ công bố", c: "#b91c1c", bg: "#fee2e2" };
};

const HappySchoolPublishLog = ({ schoolId, kind, weekId = "", monthKey = "", title = "📜 Nhật ký công bố" }) => {
  const [entries, setEntries] = useState(null);
  const [error, setError] = useState("");
  const load = useCallback(() => {
    if (!schoolId) return;
    setError("");
    getPublishLog(schoolId, { kind, weekId, monthKey })
      .then((d) => setEntries(d.entries || []))
      .catch((e) => { setError(e.message); setEntries([]); });
  }, [schoolId, kind, weekId, monthKey]);
  useEffect(() => { setEntries(null); load(); }, [load]);

  return (
    <details style={{ marginTop: 14, border: "1px solid #e5e7eb", borderRadius: 8, background: "#fff" }}>
      <summary style={{ cursor: "pointer", padding: "8px 12px", fontWeight: 700, fontSize: 14 }}>
        {title}{entries ? ` (${entries.length})` : ""}
      </summary>
      <div style={{ padding: "0 12px 12px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: "6px 0" }}>
          <span style={{ fontSize: 12, color: "#6b7280" }}>Mới nhất trước · giờ Việt Nam · chỉ ghi thêm, không sửa/xoá được.</span>
          <button type="button" onClick={load} style={{ padding: "3px 10px", border: "1px solid #d1d5db", borderRadius: 6, background: "#fff", cursor: "pointer", fontSize: 12 }}>↻ Tải lại</button>
        </div>
        {error && <p style={{ color: "#dc2626", fontSize: 13 }}>{error}</p>}
        {entries === null ? <p style={{ fontSize: 13 }}>Đang tải...</p> : entries.length === 0 ? (
          <p style={{ color: "#6b7280", fontSize: 13 }}>Chưa có lần công bố / gỡ công bố nào được ghi lại.</p>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={{ borderCollapse: "collapse", fontSize: 13, width: "100%" }}>
              <thead>
                <tr>{["Thời điểm", "Hành động", kind === "luong" ? "Tháng" : "Bản", "Người thực hiện", "Ghi chú"].map((h) => (
                  <th key={h} style={{ border: "1px solid #e5e7eb", padding: "5px 8px", background: "#f9fafb", whiteSpace: "nowrap", textAlign: "left" }}>{h}</th>
                ))}</tr>
              </thead>
              <tbody>
                {entries.map((e) => {
                  const a = actionOf(e);
                  return (
                    <tr key={e.id}>
                      <td style={cell}>{fmtAt(e.at)}</td>
                      <td style={cell}><span style={{ background: a.bg, color: a.c, borderRadius: 10, padding: "2px 8px", fontWeight: 600, whiteSpace: "nowrap", fontSize: 12 }}>{a.t}</span></td>
                      <td style={cell}>{e.kind === "luong" ? (e.monthLabel || e.monthKey) : [e.weekLabel && !weekId ? e.weekLabel : "", e.runLabel].filter(Boolean).join(" · ")}</td>
                      <td style={cell}>{e.byName || e.byUid || "—"}{e.byRole ? <span style={{ color: "#9ca3af" }}> ({e.byRole})</span> : null}</td>
                      <td style={{ ...cell, color: "#6b7280" }}>{[e.note, e.wasPublished === false && e.action === "unpublish" ? "(bản này vốn chưa công bố)" : ""].filter(Boolean).join(" ")}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </details>
  );
};
const cell = { border: "1px solid #e5e7eb", padding: "5px 8px", verticalAlign: "top" };

export default HappySchoolPublishLog;
